import { formatInrAmount } from "../utils/formatInrAmount";

/**
 * Shows list (Selling price) with strikethrough when `product.hasDiscount`, else single price.
 * `product.discountPercent` from sheet drives the offer label when > 0.
 */
export function ProductPriceBlock({ product, variant = "shop" }) {
  if (!product) return null;
  const showCompare =
    product.hasDiscount &&
    Number(product.listPrice) > 0 &&
    Number(product.price) < Number(product.listPrice) - 0.001;

  const priceClass =
    variant === "product"
      ? "price-figure price-figure--emphasis"
      : "price-figure";

  const discountPct = Math.round(Number(product.discountPercent));
  const showOfferLabel = Number.isFinite(discountPct) && discountPct > 0;

  if (showCompare) {
    return (
      <div className={`d-flex flex-wrap align-items-baseline gap-2 ${variant === "product" ? "mb-0" : ""}`}>
        <span className="product-price-compare small text-decoration-line-through">
          ₹{formatInrAmount(product.listPrice)}
        </span>
        <span className={priceClass}>
          ₹{formatInrAmount(product.price)}
        </span>
        {showOfferLabel && (
          <span
            className={`product-offer-badge align-middle ${variant === "product" ? "product-offer-badge--lg" : ""}`.trim()}
            aria-label={`${discountPct} percent off`}
          >
            Save {discountPct}%
          </span>
        )}
      </div>
    );
  }

  return <span className={priceClass}>₹{formatInrAmount(product.price)}</span>;
}
